import { memo, useEffect, useRef } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Editor, EditorInstance } from '@shared/components/Editor'
import { LoadingIndicator, NotFound } from '@shared/layouts'
import { useImageObjectUpdateMutation } from 'hooks/mutations/content/ImageObject'
import { imageRoute } from 'pages/NWPlatform/Workspaces/Workspace/Images/Image/Routing'
import { imageObjectQueryKeys } from 'services/queryKeys'

const JSONRaw = () => {
  const { t } = useTranslation(['domain'])
  const { enqueueSnackbar } = useSnackbar()

  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const { imageId } = imageRoute.useParams()

  const imageQuery = useQuery(imageObjectQueryKeys.detail({ imageId }))
  const { data: imageObject } = imageQuery

  const { mutate } = useImageObjectUpdateMutation()

  useEffect(() => {
    if (editorInstanceRef.current && imageQuery.isSuccess) {
      editorInstanceRef.current?.getModel()?.setValue(window.JSON.stringify(imageObject, null, 4))
    }
  }, [imageQuery.isSuccess, imageObject])

  if (imageQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (!imageObject) {
    return <NotFound />
  }

  return (
    <Editor
      value={imageObject}
      onSubmit={(data) => {
        mutate(
          {
            imageId: imageId,
            imageObjectEdit: data,
          },
          {
            onSuccess: () => {
              enqueueSnackbar(t('domain:Workspace.Image.imageObjectSaved'), {
                variant: 'success',
              })
            },
          },
        )
      }}
      getEditorInstance={(editorInstance: EditorInstance) => (editorInstanceRef.current = editorInstance)}
    />
  )
}

export const JSON = memo(JSONRaw)
